import styled from "styled-components";
import Button from "../../components/utils/Button/Button";
import {
  CheckboxContainer as GenerateCollectionCheckboxContainer,
  NudifyText as GenerateCollectionCheckboxText,
} from "../../components/GenerateCollectionModal/GenerateCollectionModal.styles";

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  color: #fff;
  font-family: Figtree;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: -0.075px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 16px;
  margin-left: -7px;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
`;

export const ModelTitle = styled.h1`
  color: #fff;
  font-family: Figtree;
  font-size: 26px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.1px;
  white-space: nowrap;
`;

export const ModelStatus = styled.div``;

export const StatusBadge = styled.span`
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 1px;
  background: #142743;
  width: 100%;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  svg {
    width: 24px;
    height: 24px;
    path {
      stroke-width: 1.5;
    }
  }
`;

export const ConfigSection = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  @media (max-width: 768px) {
    flex: unset;
  }
`;

export const FloatingAddButton = styled.button`
  position: fixed;
  bottom: 32px;
  right: 32px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: #2877d9;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 24px rgba(40, 119, 217, 0.45);
  z-index: 100;

  animation: ${({ $exiting }) => ($exiting ? "floatOut" : "floatIn")} 0.2s
    cubic-bezier(0.34, 1.56, 0.64, 1) forwards;

  @keyframes floatIn {
    from {
      opacity: 0;
      transform: scale(0.5) translateY(12px);
    }
    to {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
  }

  @keyframes floatOut {
    from {
      opacity: 1;
      transform: scale(1) translateY(0);
    }
    to {
      opacity: 0;
      transform: scale(0.5) translateY(12px);
    }
  }

  svg {
    width: 22px;
    height: 22px;
    path {
      stroke: white;
    }
  }

  &:hover {
    transform: scale(1.1);
    background: #3a8ae8;
    transition:
      transform 0.15s ease,
      background 0.15s ease;
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    transform: none;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 16px;
  width: 100%;
`;

export const SectionTitle = styled.h3`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const TutorialLink = styled.button`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  flex-direction: row;
  display: flex;
  padding: 12px;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
  cursor: pointer;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  line-height: 20px;

  svg {
    width: 20px;
    height: 20px;
    rotate: -180deg;
    path {
      stroke-width: 1.25;
    }
  }

  @media (max-width: 400px) {
    gap: 0;
    font-size: 13px;
    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

export const LinkText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  line-height: 20px;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 400px) {
    font-size: 13px;
  }
`;

export const FormSection = styled.div`
  margin-bottom: 32px;
`;

export const ButtonDuration = styled.button`
  flex: 1;
  height: 36px;

  background: transparent;
  border: none;

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
  z-index: 2;

  color: ${({ $active }) => ($active ? "#fff" : "rgba(255,255,255,0.6)")};

  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;

  cursor: pointer;
  transition: color 0.25s ease;
`;

export const Label = styled.label`
  color: #fff;
  font-family: Figtree;
  opacity: ${(p) => (p.$light ? 0.5 : 1)};
  font-size: ${(p) => (p.$light ? "12px" : "14px")};
  font-weight: ${(p) => (p.$light ? "400" : "500")};
  letter-spacing: -0.21px;
`;

export const Buttons = styled.div`
  display: flex;
  position: relative;
  background: #060e1a;
  border-radius: 12px;
  padding: 2px;

  &::before {
    content: "";
    position: absolute;
    top: 2px;

    left: ${({ $activeIndex, $count }) =>
      `calc(${100 / $count}% * ${$activeIndex} + 2px)`};

    width: ${({ $count }) => `calc(${100 / $count}% - 4px)`};

    height: calc(100% - 4px);

    background: #142743;
    border: 1px solid #2877d9;
    border-radius: 10px;

    transition: left 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 1;
  }
`;

export const CheckboxRow = styled(GenerateCollectionCheckboxContainer)`
  display: flex;
  margin-top: 4px;
  width: fit-content;
  flex: 0 0 auto;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
`;

export const CheckboxLabel = styled(GenerateCollectionCheckboxText)``;
export const LabelUpload = styled.label`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.09px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const TextInput = styled.input`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  display: flex;
  height: 44px;
  width: 100%;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  &:focus {
    border-color: #2877d9;
  }
`;
export const TextAreaInput = styled.textarea`
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  display: flex;
  min-height: 88px;
  width: 100%;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;

  outline: none;
  font-weight: 500;
  letter-spacing: -0.21px;

  box-sizing: border-box;
  resize: vertical;

  border-color: ${(p) => (!p.$outline ? "#325682" : "red")};
  &:focus {
    border-color: ${(p) => (!p.$outline ? "#2877d9" : "red")};
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 14px 16px;
  background: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.1)"};
  border: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.2)"};
  border-radius: 8px;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  font-size: 14px;
  box-sizing: border-box;
  resize: vertical;
  margin-bottom: 8px;
  &::placeholder {
    color: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.5)"};
  }
  &:focus {
    outline: none;
    border-color: #4deeea;
    box-shadow: 0 0 0 2px rgba(77, 238, 234, 0.2);
  }
`;

export const RequirementsSection = styled(ConfigSection)``;

export const RequirementTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  margin: 0 0 24px 0;
`;

export const RequirementText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: ${(p) => (p.$bold ? "600" : "400")};
  letter-spacing: -0.195px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4.5px;
`;

export const Text = styled.p`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.21px;
  opacity: 0.8;
`;

export const LabelColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  width: 100%;
`;

export const UploadCount = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.195px;
  display: flex;
  height: ${(p) => (p.$white ? "28px" : "24px")};
  padding: ${(p) => (p.$white ? "4px 16px" : "8px 12px")};
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  border: ${(p) => (p.$white ? "1px solid white" : "none")};
  background: ${(p) => (p.$white ? "transparent" : "#2d4a7e")};
  svg {
    width: 14px;
    height: 14px;
  }
`;

export const CostSection = styled.div`
  background: ${({ theme }) =>
    theme === "light" ? "rgba(67, 233, 123, 0.05)" : "rgba(67, 233, 123, 0.1)"};
  border: 1px solid rgba(67, 233, 123, 0.3);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  text-align: center;
`;

export const CostTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => (theme === "light" ? "#1a1a1a" : "white")};
  margin: 0 0 16px 0;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 8px;
`;

export const OriginalPrice = styled.span`
  font-size: 32px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  text-decoration: line-through;
`;

export const UploadSection = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
`;

export const UploadCard = styled.div`
  border-radius: 16px;
  border: 1px dashed #414143;
  padding: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: rgba(255, 255, 255, 0.035);
  }
`;

export const UploadCard2 = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  border: 1px dashed #315480;
  background:
    linear-gradient(0deg, #142743 0%, #142743 100%),
    url(<path-to-image>) lightgray 50% / cover no-repeat;
  cursor: pointer;

  /* Zauzima svu slobodnu širinu u redu, skuplja se kako se dodaju fajlovi */
  flex: 1;
  min-width: 150px;
  min-height: 200px;
  max-height: 220px;

  background: #142743;
  transition: background 0.3s ease-in-out;
  &:hover {
    background: rgba(255, 255, 255, 0.035);
  }

  @media (max-width: 500px) {
    min-width: 150px;
    min-height: 200px;
    max-height: 200px;
  }

  @media (max-width: 400px) {
    min-width: 130px;
    min-height: 170px;
    max-height: 170px;
  }
`;

export const UploadDescriptionText = styled.span`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: -0.408px;
  opacity: 0.5;
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

export const UploadText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: ${(props) => (props.$light ? "13px" : "18px")};
  font-weight: ${(props) => (props.$light ? 300 : 500)};
  line-height: ${(props) => (props.$light ? "18px" : "normal")};
  margin-top: ${(props) => (props.$light ? "-12px" : "0px")};
  opacity: ${(props) => (props.$light ? 0.56 : 1)};
  letter-spacing: ${(props) => (props.$light ? "0" : "-0.408px")};
  cursor: pointer;
  text-decoration-line: underline;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding-top: 32px;
  border-top: 1px solid
    ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
`;

export const DeleteButton = styled(Button)``;

export const StartTrainingButton = styled.button`
  border-radius: 100px;
  background: #fff;
  display: flex;
  width: 186px;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border: none;
  outline: none;
  cursor: pointer;
  color: #000;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 500;

  letter-spacing: -0.08px;
  transition: all 0.3s ease-in-out;
  &:hover {
    transform: translateY(-2px);
  }
`;

export const FilePreviewGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  @media (max-width: 700px) {
    align-self: center;
    justify-content: center;
  }
`;

export const FilePreviewItem = styled.div`
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  aspect-ratio: 1;
  background: #142743;
  border: 1px solid #325682;
  max-width: 170px;
  max-height: 220px;
  min-width: 150px;
  min-height: 200px;

  @media (max-width: 500px) {
    max-width: 150px;
    max-height: 200px;
    min-width: 150px;
    min-height: 200px;
  }

  @media (max-width: 400px) {
    max-width: 130px;
    max-height: 170px;
    min-width: 130px;
    min-height: 170px;
  }
`;

export const FilePreview = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  svg {
    width: 40px;
    height: 40px;
    color: #fff;
    opacity: 0.5;
  }
`;

export const RemoveFileButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 0, 0, 0.8);
  }
`;

export const FileName = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  color: #fff;
  font-size: 10px;
  padding: 8px 4px 4px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
`;

export const PageLoader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 20px;
`;

export const LoaderText = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: -0.08px;
  opacity: 0.7;
`;

export const SkeletonLoaderColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const SkeletonLoader = styled.div`
  background: linear-gradient(90deg, #152a47 0px, #23406a 40px, #152a47 80px);
  background-size: 300px 100%;
  animation: shimmer 8s infinite linear;
  border-radius: ${(props) => props.$radius || "8px"};
  height: ${(props) => props.$height || "20px"};
  max-width: ${(props) => props.$width || "100%"};
  width: 100%;

  @keyframes shimmer {
    0% {
      background-position: -300px 0;
    }
    100% {
      background-position: 300px 0;
    }
  }
`;

export const SkeletonSection = styled.div`
  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;
  /* padding: 16px; */
  display: flex;
  overflow: hidden;
  height: ${(props) => props.$height || "335px"};
  max-height: ${(props) => props.$height || "335px"};
  flex-direction: column;
  /* gap: 16px; */
  flex: 1;
`;

export const ImgContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #000;

  img {
    height: 100%;
    width: 100%;
    position: absolute;
  }
`;

export const WarningTextContainer = styled.div`
  display: flex;
  gap: 12px;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
export const WarningText = styled.span`
  max-width: 500px;
  font-family: Figtree;
  font-size: 12px;
  opacity: ${(p) => (!p.$bold ? 0.9 : 1)};
  font-weight: ${(p) => (!p.$bold ? "400" : "600")};
  color: #fff;
  letter-spacing: -0.08px;
`;

/* ============================================
   Dataset Section Styles (Train Image mode)
   ============================================ */

export const DatasetHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const DatasetHeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const AddRowButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  transition: opacity 0.2s ease-in-out;
  padding: 4px;

  &:disabled {
    opacity: 0.2;
    cursor: not-allowed;
  }
`;

export const DatasetGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const DatasetRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 16px;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const AddSetContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;

  border-radius: 16px;
  border: 1px dashed #414143;

  display: flex;
  padding: 12px 12px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  cursor: pointer;

  color: #fff;
  text-align: justify;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.408px;

  background: #142743;
  transition: background 0.3s ease-in-out;
  &:hover {
    background: rgba(255, 255, 255, 0.035);
  }
`;

export const DatasetRowNumber = styled.div`
  color: #fff;
  font-family: Figtree;
  font-size: 32px;
  font-weight: 300;
  letter-spacing: -0.5px;
  opacity: 0.3;
  display: flex;
  align-items: center;
  min-width: 32px;
  user-select: none;
`;

export const DatasetRowContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex: 1;
  align-items: center;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const DatasetColumnLabel = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  opacity: 0.5;
  margin-bottom: 8px;
`;

export const DatasetColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const DatasetArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4d8dff;
  opacity: 0.6;
  flex-shrink: 0;
  padding-top: 20px;

  @media (max-width: 600px) {
    padding-top: 0;
    transform: rotate(90deg);
  }
`;

export const DatasetUploadCard = styled.div`
  display: flex;
  height: 140px;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
  border-radius: 12px;
  border: 1px dashed #315480;
  background: #142743;
  cursor: ${(props) => (props.$disabled ? "default" : "pointer")};
  transition: all 0.2s ease-in-out;
  position: relative;
  overflow: hidden;

  &:hover {
    ${(props) =>
      !props.$disabled &&
      `
      border-color: #4d8dff;
      background: rgba(77, 141, 255, 0.03);
    `}
  }

  img {
    width: auto;
    height: 100%;
  }
`;

export const DatasetUploadText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const DatasetUploadSubtext = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: -0.18px;
  opacity: 0.5;
`;

export const DatasetRemoveRowButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0.5;
  transition: opacity 0.2s ease-in-out;
  padding: 4px;
  padding-top: 20px;
  flex-shrink: 0;

  ${DatasetRow}:hover & {
    opacity: 0.75;
  }

  &:hover {
    opacity: 1 !important;
  }
`;

export const DatasetRemoveFileButton = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 28px;
  height: 29px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  padding-bottom: 1px;
  align-items: center;
  justify-content: center;
  z-index: 2;
  transition: all 0.2s ease;

  background: rgba(0, 0, 0, 0.5);
`;
